import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Api from '../../../../common/services/api';
import { DialogWrapper } from '../../../../common/components/modal/dialog-wrapper';
import SearchableList from '../../../../common/components/list/search';
import { Role, User } from '@common/types/objects';
import { useAppSelector } from '@common/hooks';
import * as organisationSelectors from '@modules/organisation/selectors/organisation';
import { Link } from 'react-router-dom';
import Profile from '@common/components/profile';

interface RoleUsersModelProps {
  children: React.ReactNode;
  role: Role;
}

const RoleUsersModel = ({ children, role }: RoleUsersModelProps) => {
  const { t } = useTranslation();
  const organisation = useAppSelector(organisationSelectors.selected);
  const handleRequest = (nextCursor: string | null, filter: any, limit = 15) => {
    const baseUrl = `/v1/organisations/${organisation.id}/roles/${role.id}/users`;
    return Api.get(`${baseUrl}?${Api.utils.toQuery({
      ...(nextCursor ? { cursor: nextCursor } : { cursor: true }),
      limit,
      search: filter.query,
    })}`);
  };

  return (
    <DialogWrapper
      title={<span><Trans i18nKey="organisation:role_title" values={{ roleName: role.name }} /></span>}
      content={
        <SearchableList
          data={{
            onFetch: handleRequest,
            useCursor: true,
          }}
          renderRow={(props: any) => (
            <Link
              to={`/admin/users/${props.item.id}/about`}
              target="_blank"
              className="tw-text-inherit hover:tw-text-inherit tw-block tw-mb-2 last:tw-mb-0"
            >
              <Profile {...props} />
            </Link>)}
          rowProps={(user: User) => ({
            mask: true,
            image: user.profile_img,
            name: user.full_name,
            user: {
              id: user.id,
              full_name: user.full_name,
              profile_img: user.profile_img,
            },
            size: 35,
            enablePopover: true,
          })}
          containerClassName="ItemsList"
          placeholder={t('organisation:role_placeholder')}
        />
      }
    >
      {children}
    </DialogWrapper>
  );

};

export default RoleUsersModel;
